const checkDashboardStatus = () => {
  const isAir = (process) => process.transportationModality === "Aéreo";

  const isPending = (process) => process.status === "PENDING";

  const isPreBoarding = (process) => {
    if (
      process.transportationModality === "Aéreo" &&
      process.kanbanStatus === "Pré embarque"
    ) {
      return process;
    }
    //kanbanStatus === "Pré embarque" e microStatus !== "Novo Processo" ou microStatus !== "NENHUM"
    return (
      (process.kanbanStatus === "Pré embarque" &&
        process.microStatus !== "Novo Processo" &&
        process.microStatus !== "NENHUM") ||
      ["SCHEDULED", "LOADED"].includes(process.status)
    );
  };

  const isOnBoarding = (process) => {
    if (
      process.transportationModality === "Aéreo" &&
      process.kanbanStatus === "Em trânsito"
    ) {
      return process;
    }
    return (
      process.kanbanStatus === "Em trânsito" || process.status === "DEPARTED"
    );
  };

  const isFinish = (process) => {
    if (isAir(process) && process.kanbanStatus === "Desembarcado") {
      return process;
    }
    return (
      process.kanbanStatus === "Desembarcado" ||
      process.status === "ARRIVED" ||
      process.status === "DISCHARGED"
    );
  };

  return {
    isPending,
    isPreBoarding,
    isOnBoarding,
    isFinish,
  };
};

export default checkDashboardStatus;
